import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

/** URL sicuro per <img> con auth. Ritorna un blob URL da revocare in cleanup. */
export async function fetchImageBlobUrl(path) {
  const token = localStorage.getItem("token");
  const res = await axios.get(`${API}/files/${path}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    responseType: "blob",
  });
  return URL.createObjectURL(res.data);
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem("token")) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      if (!window.location.pathname.startsWith("/clone/")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
